import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box } from "@mui/material";
import { styles } from "./styles";
import { freePlanFeatures } from "./helper";

export const FreePlanDetails = () => {
  return (
    <Box>
      <ul style={styles.minorPlanFeatureUl}>
        {freePlanFeatures.map((feature, index) => (
          <li key={index} style={styles.planDetailsRow}>
            <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
            {feature}
          </li>
        ))}
      </ul>
    </Box>
  );
};
